<div class="control-section-x multiple">

</div>

<ejs-dialog #modal [isModal]='true' 
    [header]="'Cadastro de Histórico do Paciente'" 
    id="historica-clinica-cadastro"
    [visible]="false"
    width="700px"
    [ngClass]="{ 'em-operacao': emOperacao }"
    height="590px"
    [enableResize]="true"
    [allowDragging]="true"
    (open)="modalOk=true"
    (close)="modalOk=false"
    class="custom-dialog"
    [showCloseIcon]='true' [id]="id"
    (beforeClose)="fechandoModal($event)"
    (beforeOpen)="tabOk=true"
    [closeOnEscape]='true'>

    <ng-template #content>
        <ejs-tab  #tab class='e-fill' *ngIf="tabOk">
            <div class="e-tab-header">
                <div>Informações Gerais</div>
            </div>
            <div class="e-content">
                <div class="" style="padding: 15px">
                    <form [formGroup]='modelo' [ngClass]="{'submitted': submetido}">
                        <div class='row' style="width: 100%">
                            <div class="col-md-4 form-group">
                                <ejs-textbox [floatLabelType]="'Always'" formControlName='pessoaNome' [placeholder]="'Paciente'" [enabled]="false"></ejs-textbox>
                            </div>
                            <div class="col-md-4 form-group">
                                <ejs-textbox [floatLabelType]="'Always'" formControlName='pessoaCpf' [placeholder]="'CPF'" [enabled]="false"></ejs-textbox>
                            </div>
                            <div class="col-md-4 form-group" required>
                                <ejs-datepicker [floatLabelType]="'Always'" formControlName='data' 
                                [placeholder]="'Data'" [enabled]="!apenasConsulta"></ejs-datepicker>
                                <app-error-handler [control]="modelo.get('data')"
                                [submitted]='submetido' [errorType]="'required'">
                                </app-error-handler>
                            </div>
                        </div>
                        <div class='row' style="width: 100%" required>
                            <div class="col-md-12 form-group" *ngIf="modalOk">
                                <app-texto-editor-cid
                                [label]="'Descrição (digite @ para buscar CIDs)...'" 
                                [formControlName]="'historico'"
                                (textoResetado)="carregarUltimoHistorico()"
                                (cidAdicionado)="onCidAdicionadoNoTexto($event)"
                                (cidRemovido)="onCidRemovidoDoTexto($event)"></app-texto-editor-cid>
                                <app-error-handler [control]="modelo.get('historico')"
                                [submitted]='submetido' [errorType]="'required'">
                                </app-error-handler>
                            </div>
                        </div>
                        <div class='row' style="width: 100%">
                            <div class="col-md-12">
                                <div style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 15px; background-color: #f9f9f9; margin-bottom: 10px;">
                                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                                        <h4 style="margin: 0; flex: 1; color: #333; display: flex; align-items: center; gap: 8px;">
                                            Doenças (CIDs)
                                            <ejs-tooltip 
                                                #cidTooltip
                                                [content]="'<strong>Como funciona:</strong><br>• Para INATIVAR uma doença: clique na seta para baixo (<i class=&quot;fas fa-chevron-down&quot;></i>) na caixa de Doenças Ativas<br>• Para ATIVAR uma doença: clique na seta para cima (<i class=&quot;fas fa-chevron-up&quot;></i>) na caixa de Doenças Inativas<br>• Para adicionar uma nova doença: clique no botão &quot;Adicionar Doença&quot;<br><br><strong>Importante:</strong><br>• O status das doenças (ativo/inativo) refere-se à situação atual do colaborador, independentemente da data desta história clínica.<br>• As alterações nas doenças só serão salvas após clicar em &quot;Salvar&quot; ou &quot;Salvar e Fechar&quot;.'"
                                                [position]="'BottomCenter'"
                                                [openDelay]="100"
                                                [cssClass]="'cid-tooltip-custom'"
                                                [windowCollision]="true">
                                                <i class="fas fa-question-circle" 
                                                   style="color: #085ca0; font-size: 16px; cursor: help;"></i>
                                            </ejs-tooltip>
                                        </h4>
                                        <button ejs-button iconCss="fas fa-history" 
                                            cssClass="e-small e-info" 
                                            (click)="abrirHistoricoDoencas()" 
                                            style="margin-right: 8px;">
                                            Histórico de Doenças
                                        </button>
                                        <button ejs-button iconCss="fas fa-plus" 
                                            cssClass="e-small e-success" 
                                            (click)="abrirPesquisaCid()" 
                                            [disabled]="apenasConsulta">
                                            Adicionar Doença
                                        </button>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 form-group">
                                            <ejs-multiselect 
                                                [dataSource]="cidsAtivos" 
                                                [fields]="{ text: 'cid10Texto', value: 'cid10Id' }"
                                                [placeholder]="'Doenças Ativas'"
                                                [floatLabelType]="'Always'"
                                                [mode]="'Box'"
                                                cssClass="cids-ativos-multiselect"
                                                [(value)]="cidsAtivosValue"
                                                (removed)="onCidsAtivosRemoved($event)"
                                                [enabled]="!apenasConsulta">
                                            </ejs-multiselect>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <ejs-multiselect 
                                                [dataSource]="cidsInativos" 
                                                [fields]="{ text: 'cid10Texto', value: 'cid10Id' }"
                                                [placeholder]="'Doenças Inativas'"
                                                [floatLabelType]="'Always'"
                                                [mode]="'Box'"
                                                cssClass="cids-inativos-multiselect"
                                                [(value)]="cidsInativosValue"
                                                (removed)="onCidsInativosRemoved($event)"
                                                [enabled]="!apenasConsulta">
                                            </ejs-multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='row' style="width: 100%">
                            <div class="col-md-8 form-group">
                                <ejs-textbox [floatLabelType]="'Always'" formControlName='profissionalNome' [placeholder]="'Profissional'" [enabled]="false"></ejs-textbox>
                            </div>
                            <div class="col-md-4 form-group">
                                <ejs-textbox [floatLabelType]="'Always'" formControlName='profissionalConselho' [placeholder]="'Conselho'" [enabled]="false"></ejs-textbox>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ejs-tab>
    
    
    </ng-template>
    
    <ng-template #footerTemplate>
        <button  ejs-button  class=" e-btn e-primary" data-ripple="true" appDebounceClick
        [iconCss]="'fas fa-save'" [disabled]="apenasConsulta"
        (click)='salvar()'>Salvar</button>
        <button  ejs-button  class=" e-btn e-primary" data-ripple="true" appDebounceClick
        [iconCss]="'fas fa-save'" [disabled]="apenasConsulta"
        (click)='salvar(true)'>Salvar e Fechar</button>
        <button  ejs-button  class=" e-btn e-danger" data-ripple="true" appDebounceClick
        [iconCss]="'fas fa-trash'" (click)="excluir()" [disabled]="apenasConsulta">Excluir</button>
        <button ejs-button  class="e-btn " data-ripple="true" (click)='cancelar()'>Cancelar</button>
        <button ejs-button   [iconCss]="'fas fa-print'" class="e-btn e-info" data-ripple="true" (click)='imprimirHistoriaClinica()'>História Clínica</button>
    </ng-template>

</ejs-dialog>

<app-cid10-search #cid10Pesquisa (registroSelecionado)="cid10Selecionado($event)"></app-cid10-search>

<app-doenca-historico-lista #doencaHistorico (fechou)="recarregarCids()"></app-doenca-historico-lista>
